import {all} from "redux-saga/effects";
import {watchAppActions} from "./authSagas";
import {watchDadosUsuarioActions} from "./dadosUsuarioSagas";
import {watchSecurityAndLoginActions} from "./securityAndLoginSagas";

export default function* rootSaga() {
    yield all([
        watchAppActions(),
        watchDadosUsuarioActions(),
        watchSecurityAndLoginActions()
    ])
}
